import RadioButtonGroupPresentation from 'components/RadioButtonGroup/RadioButtonGroupPresentation'

export default {
  Presentation: RadioButtonGroupPresentation,
}
